import { render, staticRenderFns } from "./responsbility.vue?vue&type=template&id=6016bb75&"
import script from "./responsbility.vue?vue&type=script&lang=js&"
export * from "./responsbility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports